import styled, { css, FlattenSimpleInterpolation } from 'styled-components';

const INFO_ICON_COLOR = 'rgba(0, 110, 228, 1)';
const INFO_BANNER_BACKGROUND = 'rgba(229, 240, 252, 1)';

export const StyledMachineRobotBasicModeActions = styled.div`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    display: flex;
    flex-direction: column;
    gap: ${kcc.spacing.SM};
    width: 100%;

    .machine-robot-basic-mode__buttons {
      display: flex;
      justify-content: center;
      gap: ${kcc.spacing.SM};
    }

    /* Beep / Blink that is currently on */
    && .machine-robot-basic-mode__button--active:not(:disabled) {
      color: ${kcc.colors.WHITE};
      background: ${kcc.colors.GRAY_950};
      border-color: ${kcc.colors.GRAY_950};

      .ant-btn-icon svg path {
        fill: ${kcc.colors.WHITE};
      }
    }
  `}
`;

export const BasicModeInfoBanner = styled.div`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    display: flex;
    align-items: flex-start;
    gap: ${kcc.spacing.SM};
    box-sizing: border-box;
    min-height: 84px;
    padding: ${kcc.spacing.MD};
    background-color: ${INFO_BANNER_BACKGROUND};
    font-size: ${kcc.typography.FONT_SIZE.BASE}px;
    line-height: 20px;
    color: ${kcc.colors.TEXT};

    .basic-mode-banner__info-icon {
      flex-shrink: 0;
      width: 32px;
      height: 32px;
      color: ${INFO_ICON_COLOR};
    }

    .basic-mode-banner__text {
      display: flex;
      flex: 1;
      flex-direction: column;
      gap: ${kcc.spacing.XXS};
      min-width: 0;
    }

    .basic-mode-banner__title {
      margin: 0;
      font-weight: ${kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
    }

    .basic-mode-banner__description {
      margin: 0;
      font-weight: ${kcc.typography.FONT_WEIGHT.REGULAR};
    }

    .basic-mode-banner__close {
      display: flex;
      flex-shrink: 0;
      align-items: flex-start;
      justify-content: center;
      width: 24px;
      height: 24px;
      padding: 0;
      border: none;
      background: transparent;
      color: ${kcc.colors.TEXT};
      cursor: pointer;
    }
  `}
`;
